<div class="dashboard" *ngIf="showHeaderContent">
  <nav class="navbar navbar-expand navclass">
    <div class="container">
      <ul class="navbar-nav">
        <li class="nav-item mr-3" *ngIf="pagePermition.includes('Works Review')" >
          <a class="nav-link nr-navbar-text" routerLink="/dashboard" routerLinkActive="nav-admin-active">Works Review</a>
        </li>
        <li class="nav-item ml-3 mr-3" *ngIf="pagePermition.includes('Standards Management')">
          <a class="nav-link nr-navbar-text" routerLink="/standards/sms-links" routerLinkActive="nav-admin-active">Standards Management</a>
        </li>
        <li class="nav-item ml-3 mr-3" *ngIf="pagePermition.includes('User Management')">
          <a class="nav-link nr-navbar-text" routerLink="/admin/manage-users" routerLinkActive="nav-admin-active">User Management</a>
        </li>
        <li class="nav-item ml-3 mr-3" *ngIf="pagePermition.includes('Notifications')">
          <a class="nav-link nr-navbar-text" routerLink="/notification" routerLinkActive="nav-admin-active">Notifications</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
